import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Session, getSession } from '@ipreo/muni-shared';
import { ShowMarketDrawers } from '../../../state/data/actions';
import { GameDayRootReducerState } from '../../../state/root.state';
import { getGamedayLoadingState } from '../../../state/data/reducer';
import { FirstLoadService } from '../../services/first-load.service';

@Component({
  selector: 'muni-gameday-overview',
  templateUrl: './overview.template.html',
  animations: [
    trigger('routeAnimation', [
      transition('void => right', [
        style({ transform: 'translateX(100%)' }),
        animate('500ms ease-in-out')
      ]),
      transition('* => void', [
        animate('500ms ease-in-out', style({ transform: 'translateX(0%)' }))
      ])
    ])
  ],
  styleUrls: ['./overview.styles.scss'],
  standalone: false
})
export class OverviewComponent implements OnInit, OnDestroy {
  public animationState: string;

  @HostBinding('@routeAnimation')
  public get routeAnimation(): string {
    return this.animationState;
  }

  public readonly isLoading: Observable<boolean> = this.store.pipe(
    select(getGamedayLoadingState)
  );

  public readonly marketDrawerEnabled: Observable<boolean> = this.store.pipe(
    select(getSession),
    filter((session: Session.SessionModel) => !!session),
    map(
      ({ deptType }: Session.SessionModel) =>
        deptType !== Session.DeptType.SyndDesk
    )
  );

  public readonly dealDate: Observable<string>;

  public readonly queryParams: Observable<Record<string, unknown>>;

  constructor(
    private store: Store<GameDayRootReducerState>,
    private firstLoadService: FirstLoadService
  ) {
    if (this.firstLoadService.firstLoad) {
      this.animationState = 'none';
    } else {
      // Router state is not available in GameDayRootReducerState
      // Default to animation for non-first loads
      this.animationState = 'right';
    }
  }

  public ngOnInit(): void {
    this.store.dispatch(new ShowMarketDrawers(true));
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new ShowMarketDrawers(false));
  }
}
